import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { UserInfo } from 'src/app/model/User';
import { AuthenticationService } from 'src/app/service/authentication.service';
import { DataService } from 'src/app/service/data.service';
import { Utils } from 'src/app/utils';
import { TreeItem } from '../controls/tree/tree.component';

@Component({
    selector: 'app-settings',
    templateUrl: './settings.component.html',
    styleUrls: ['./settings.component.css'],
    standalone: false
})
export class SettingsComponent implements OnInit {

  title: string;
  menuItems: TreeItem[];
  url: string;
  currentUserAuthInfo: UserInfo;
  
  constructor(private router: Router,
              private dataSrv: DataService,
              private route: ActivatedRoute,
              private authService: AuthenticationService,) {}

  ngOnInit(): void {
    this.currentUserAuthInfo = this.authService.getLoggedInUser();
    this.menuItems = Utils.getSettingsMenu(this.currentUserAuthInfo);
    this.url = this.router.routerState.snapshot.url;

    this.router.events.subscribe(event =>{
      if(event instanceof NavigationEnd){
        this.url = this.router.routerState.snapshot.url;
      }
    });
  }
}
